<template>
  <ReportAgent
    :urls="urls"
    :mandatory-filter="[
      {
        name: 'date_range',
        title: 'Date range',
        valueFieldName: '.select',
      },
    ]"
  />
</template>

<script>
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import ReportAgent from "@/own/components/reports/ReportAgent";
export default {
  name: "LastMileForwardLeg",
  components: { ReportAgent },
  data: () => ({
    urls: {
      data_url: "/reports/lastMileForwardLeg",
      show_url: "/reports/lastMileForwardLeg/show",
    },
  }),
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
  },
};
</script>
